module.exports = __webpack_public_path__ + "static/images/edit.8f4bf2f80f6a2889cc57e678703acb5b.svg";